import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { makeStyles } from '@mui/styles'
import type { Nil } from '@pbt/pbt-ui-components'

import SelectableListWithFilters from '~/components/common/list-with-filters/SelectableListWithFilters'
import { fetchVaccines } from '~/store/actions/medicalHistory'
import {
  getMedicalHistoryIsFetching,
  getMedicalHistoryIsSending,
  getMedicalHistoryVaccines,
} from '~/store/reducers/medicalHistory'
import type { VaccineHistoryItem } from '~/types'

import VaccineHistoryExpandedDetails from './VaccineHistoryExpandedDetails'

const useStyles = makeStyles(
  () => ({
    selectableListContainer: {
      padding: 0,
    },
  }),
  { name: 'AttachmentListWithFilters' },
)

interface VaccineListWithFiltersProps {
  onProceed: (items: VaccineHistoryItem[]) => void
  patientId: string | Nil
}

const VaccineListWithFilters = ({
  patientId,
  ...rest
}: VaccineListWithFiltersProps) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { t } = useTranslation(['Common', 'Search'])

  const isSending = useSelector(getMedicalHistoryIsSending)
  const isFetching = useSelector(getMedicalHistoryIsFetching)
  const vaccines = useSelector(getMedicalHistoryVaccines)

  const loadNewItems = () => {
    if (patientId) {
      dispatch(fetchVaccines(patientId))
    }
  }

  return (
    <SelectableListWithFilters
      hideFilters
      DetailsComponent={VaccineHistoryExpandedDetails}
      ListItemProps={{
        showListItemActions: true,
      }}
      classes={{
        container: classes.selectableListContainer,
      }}
      isLoading={isSending}
      isReceivingListItems={isFetching}
      items={vaccines}
      loadNewItems={loadNewItems}
      patientId={patientId}
      proceedButtonLabel={t('Common:ADD_TO_TIMELINE')}
      searchPlaceholder={t('Search:VACCINES')}
      {...rest}
    />
  )
}

export default VaccineListWithFilters
